import React, { useEffect } from 'react';
import report from '../../assets/report.png';
import close from '../../assets/close.svg';
import info from '../../assets/info.png';


const Reports = React.memo(({ simObj, setSimObj, updateReadStatus, closePopups, replaceVariables, popupLeft, addSpaceAfterDot }) => {
  useEffect(() => {
    window.jQuery('.item').tab();
    if(document.querySelector(".report-box .ui.list .tab-item.active")){
    document.querySelector(".report-box .ui.list .tab-item.active").click();
  }

  }, []);

  useEffect(() => {
    const ua = navigator.userAgent;
    // Detect iOS devices (including iPadOS that reports as Mac)
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Detect Android tablets (Android but not phones)
    const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
    
    if (isIOS || isAndroidTablet) {
      const popupBox = document.querySelector(
        '.ui.raised.popup-box'
      );

      if (popupBox) {
        popupBox.setAttribute('tabindex', '-1'); // 👈 make it focusable
      } 

      const dialog = document.querySelector('.report-box .popup-box[role="dialog"]');
      setTimeout(() => {
        if (dialog) {
          dialog.focus();
        }
      }, 1000);
    }
  }, []);
  // useEffect(()=>{
  //   document.querySelector(".popup-container .header-box h2").tabIndex = -1;
  //   document.querySelector(".popup-container .header-box h2").focus();
  // },[]);

  return (
    <div className='ui pointing label popup-container report-box' style={{ "--left": `${popupLeft}px` }}>
      {/* <div className="polygon reports"></div> */}
      <div className="ui raised very padded text container segment popup-box" role="dialog" aria-modal="true" aria-labelledby="reportsModal">
        <div className="header-box">
          <div>
            <img className="image textmsg icon" src={report} alt="" />
            <h2 id="reportsModal" className="title" tabIndex={-1}>REPORTS AND MEMOS</h2>
          </div>
          <div className='close-popup' onClick={closePopups}>
            <a role="button" href="#" aria-label='Close'><img src={close} alt="" /></a>
          </div>

        </div>
        <div className="section">
          {
          simObj?.artifacts?.filter((data) => data.md == "REPORTS").length > 0 ?
          (<div className="ui stackable two column grid">
            <div className="six wide column">
              <div className="ui secondary segment">
                <ul className="ui divided list" role="tablist" aria-label="Reports tabs">
                  {simObj?.artifacts?.filter((data) => data.md == "REPORTS").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                    <li id={data.aii} key={data.aii} onKeyDown={(e)=> e.key == "Enter" && e.currentTarget.click()} className={`item tab-item ${(index == 0) || (data.ci == data.aii) ? 'active' : ''} ${(data.rs == 1) ? 'visited' : ''}`} data-tab={"tab-" + data.aii} onClick={updateReadStatus} role='tab' tabIndex={index == 0 ? 0 :-1}  aria-selected={index==0} aria-controls={`tab_${data.aii}_tab`}>
                      <div className="content">
                        <p style={(simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? {gridTemplateColumns: '25px auto 16px'} : {}}>
                          <span className="sr-only">
                          {data.rs==1 ? "Visited:" : "Not Visited:"}
                              </span>
                          <a></a>
                          <span className="left floated">{data.val.artifactName == '' ? "No Subject" : data.val.artifactName}</span>
                          {
                            (simObj?.impArtifacts && simObj?.impArtifacts?.indexOf(data.ai) != -1) ? <img src={info} alt="" /> :''
                          }
                          {/* <span className="right floated">{"10:30"}</span> */}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="ten wide column" tabIndex={-1}>
              <div>
              {simObj.artifacts.filter((data) => data.md == "REPORTS").sort((a, b) => ((b.aii < a.aii) ? -1 : 1)).sort((a, b) => (b.cr - a.cr)).map((data, index) => (
                  <div className={`ui tab ${index == 0 ? "active" : ""}`} key={data.aii} data-tab={"tab-" + data.aii} id={`tab_${data.aii}_tab`} role="tabpanel" aria-labelledby={data.aii} tabIndex={index==0 ? 0 : -1} hidden>
                    <div className='report-box-container'>
                      <h3>{data.val.artifactName}</h3>
                      <div className='msg-body' dangerouslySetInnerHTML={{
                        __html: replaceVariables(addSpaceAfterDot(data.val.value))
                      }}>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>)
          :
          (<div className='empty ui stackable grid'>
                <div className="column">
                  <div className="ui info message">
                    <div className="header">
                        There are no reports and memos for this category.
                    </div>
                  </div>
                </div>
          </div>)
         }
        </div>
      </div>
    </div>
  )
})

export default Reports